var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplication(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50039 4.05H7.10039C6.43765 4.05 5.90039 4.58726 5.90039 5.25V19.65C5.90039 20.3127 6.43765 20.85 7.10039 20.85H17.9004C18.5631 20.85 19.1004 20.3127 19.1004 19.65V5.25C19.1004 4.58726 18.5631 4.05 17.9004 4.05H15.5004M9.50039 4.05C9.50039 4.71274 10.0376 5.25 10.7004 5.25H14.3004C14.9631 5.25 15.5004 4.71274 15.5004 4.05M9.50039 4.05C9.50039 3.38726 10.0376 2.85 10.7004 2.85H14.3004C14.9631 2.85 15.5004 3.38726 15.5004 4.05M8.90039 7.65H16.1004M8.90039 10.05H13.7004M8.90039 12.45H16.1004M8.90039 14.85H13.7004M8.90039 17.25H16.1004M11.9004 2.85H13.1004C13.2661 2.85 13.4004 2.71569 13.4004 2.55C13.4004 2.38431 13.2661 2.25 13.1004 2.25H11.9004C11.7347 2.25 11.6004 2.38431 11.6004 2.55C11.6004 2.71569 11.7347 2.85 11.9004 2.85Z",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplication);
export default __webpack_public_path__ + "static/media/application.a3daa05c.svg";
export { ForwardRef as ReactComponent };